/**
 * Wording rules for the automated texts sent to customers (t1190). Carriers
 * reviewing the SMS campaign expect every message to open with the brand and
 * the non-transactional ones to say how to opt out.
 */
export const SMS_BRAND = 'Mevaser Tech';
export const SMS_OPT_OUT = 'Reply STOP to opt out.';
const MENTIONS_STOP = /\breply\s+stop\b/i;
/** True when the text already tells the reader to reply STOP. */
export function mentionsSmsOptOut(body) {
    return MENTIONS_STOP.test(body);
}
/** Appends the opt-out line unless the text already tells the reader to reply STOP. */
export function withSmsOptOut(body) {
    const text = body.trimEnd();
    return MENTIONS_STOP.test(text) ? text : `${text} ${SMS_OPT_OUT}`;
}
const STARTS_WITH_BRAND = /^mevaser\s*tech\b/i;
/** Opens the text with the brand unless it already does. */
export function withSmsBrand(body) {
    const text = body.trim();
    return STARTS_WITH_BRAND.test(text) ? text : `${SMS_BRAND}: ${text}`;
}
/**
 * A support text sets its opt-out line apart with a gap and a marker, since
 * SMS can't make it smaller or lighter (t1234). Swap the marker here only.
 */
export const SMS_OPT_OUT_MARKER = '     >';
export const SMS_TICKET_OPT_OUT = `${SMS_OPT_OUT_MARKER}${SMS_OPT_OUT}`;
/** Brand first, opt-out last — what carriers expect on a support text (t1194). */
export function withSmsCompliance(body) {
    const text = withSmsBrand(body).trimEnd();
    return MENTIONS_STOP.test(text) ? text : `${text}${SMS_TICKET_OPT_OUT}`;
}
const AUTO_BRAND = new RegExp(`^${SMS_BRAND}:\\s*`);
const AUTO_OPT_OUT = /\s*>?Reply STOP to opt out\.$/;
/**
 * Splits a sent text into the wording `withSmsCompliance` added and what staff
 * wrote, so the portal can show the added parts muted. Matches older texts
 * sent before the marker too; a missing part comes back as ''.
 */
export function splitSmsCompliance(body) {
    let text = body;
    const brand = text.match(AUTO_BRAND)?.[0] ?? '';
    text = text.slice(brand.length);
    const optOut = text.match(AUTO_OPT_OUT)?.[0] ?? '';
    text = text.slice(0, text.length - optOut.length);
    return { brand: brand.trim(), text, optOut: optOut.trim() };
}
const CARRIER_KEYWORDS = new Set([
    'stop',
    'stopall',
    'unsubscribe',
    'cancel',
    'end',
    'quit',
    'help',
    'info',
    'start',
]);
/** An inbound text that is only a STOP/HELP-style keyword, which the SMS provider answers itself. */
export function isSmsKeyword(body) {
    return CARRIER_KEYWORDS.has(body
        .trim()
        .toLowerCase()
        .replace(/[.!]+$/, ''));
}
/**
 * Whether a ticket text should carry the brand and opt-out wording (t1233).
 * `every_text` always does; `first_and_periodic` does on the ticket's first
 * text and again once the last text that carried it is `intervalDays` old.
 */
export function smsComplianceDue(input) {
    if (input.mode === 'every_text' || !input.lastComplianceAt)
        return true;
    const ageMs = (input.now ?? new Date()).getTime() - input.lastComplianceAt.getTime();
    return ageMs >= input.intervalDays * 24 * 60 * 60 * 1000;
}
//# sourceMappingURL=sms.js.map